import * as ents from '@attain-apps/entities'

/**
 * State for the survey configuration feature, shared between Space Full and
 * Space Lite
 */
export interface State {
  /**
   * Current config payload returned by the API, if one exists.
   * `functionalUsage` is only present when deployed (Space Full).
   */
  config?: ents.extra.space.SurveyConfiguration
  /**
   * Locally edited functional-usage configuration values
   *
   * @default ents.extra.space.SurveyConfiguration.Input.DEFAULT
   */
  editedConfig?: ents.extra.space.SurveyConfiguration.Input
  /**
   * Latest load or save error surfaced by the feature
   */
  error?: Error
  /**
   * Indicates the feature is currently loading config data
   */
  isLoading: boolean
}

export namespace State {
  export const INITIAL: Readonly<State> = {
    config: undefined,
    editedConfig: undefined,
    error: undefined,
    isLoading: false,
  }

  /**
   * The locally edited config as a full
   * {@link ents.extra.space.SurveyConfiguration.Input}, falling back to
   * {@link ents.extra.space.SurveyConfiguration.Input.DEFAULT} when nothing has
   * been edited or loaded yet.
   */
  export function editedConfigOrDefault(
    state: State,
  ): ents.extra.space.SurveyConfiguration.Input {
    return (
      state.editedConfig ?? ents.extra.space.SurveyConfiguration.Input.DEFAULT
    )
  }
}
